export default {
    "activatedFlag": false,
    "participantPhoneNumber": "2222222222",
    "planNumber": "805222"
}

